import React from 'react';
import SvgIconDPC from "../dpc-svg-icon";

export default class DpcCard extends React.Component {

    titleCase(str) {
        const splitStr = str.toLowerCase().split(' ');
        for (let i = 0; i < splitStr.length; i++) {
            // You do not need to check if i is larger than splitStr length, as your for does that for you
            // Assign it back to the array
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        // Directly return the joined string
        return splitStr.join(' ');
    }

    render() {
        return (
            <article className="card-wrapper card-space">
                <div className="card card-img">

                    <div className="img-responsive-wrapper">
                        <div className="img-responsive">
                            {this.props.element?.image &&
                            <figure className='img-wrapper'>
                                <figcaption className="sr-only">{this.props.element?.didascalia}</figcaption>
                                <a href={this.props.element?.slug}>
                                    <img alt={this.props.element?.alt} src={this.props.element?.image}/>
                                </a>
                            </figure>
                            }
                        </div>
                    </div>

                    <div className="card-body">
                        {this.props.element?.categoria &&
                        <div className="category-top">
                            <span className="category">{this.titleCase(this.props.element?.categoria)}</span>
                        </div>
                        }
                        <h3 className="card-title"><a href={this.props.element?.slug}>{this.props.element?.title}</a></h3>
                    </div>
                </div>
            </article>
        )
    }
}
